"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Raw = void 0;
var react_1 = __importDefault(require("react"));
exports.Raw = function (_a) {
    var children = _a.children;
    return react_1["default"].createElement(react_1["default"].Fragment, null, children);
};
//# sourceMappingURL=Raw.js.map